<template>
  <div class="calculations-container">
    <h1 class="calculations-header">Расчеты</h1>
    <div class="buttons-container">
      <button v-if="!isCreating" class="new-button" @click="isCreating = true">Новый рассчет</button>
      <button v-else class="close-button" @click="isCreating = false">Закрыть</button>
    </div>
    <div class="calculator-section" v-if="isCreating">
      <CalculatorForm @close="toggleCreating" />
    </div>

    <div v-else class="calculator-table">
      <CalculatorTable />
    </div>
  </div>
</template>
  
<script>
import { ref } from "vue";
import CalculatorForm from "@/pages/trade/components/CalculatorForm.vue";
import CalculatorTable from "@/pages/trade/components/CalculatorTable.vue";

export default {
  components: { CalculatorForm, CalculatorTable },
  setup() {
    const isCreating = ref(false);

    const toggleCreating = () => {
      isCreating.value = !isCreating.value;
    };

    return {
      isCreating,
      toggleCreating,
    };
  },
};
</script>

<style scoped>
.calculations-container {
  padding: 15px;
  background-color: #ffffff;
  min-height: 100vh;
}

.calculations-header {
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 16px;
}

.create-button {
  background-color: #2563eb;
  color: #ffffff;
  padding: 10px 16px;
  border-radius: 8px;
  transition: background-color 0.2s ease-in-out;
  font-weight: 500;
}

.create-button:hover {
  background-color: #1e40af;
}

.calculator-section {
  margin-top: 24px;
  padding: 16px;
}

.calculator-table {
  margin-top: 24px;
}

.buttons-container {
  display: flex;
  gap: 10px;
}

.buttons-container button {
  padding: 10px 15px;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.buttons-container .new-button {
  background-color: rgba(33, 136, 56,0.5);
  
}

.buttons-container .new-button:hover {
  background-color: rgba(33, 136, 56,0.7);
}

.buttons-container .upload-button {
  background-color: rgba(0, 123, 255,0.5);
  
}

.buttons-container .upload-button:hover {
  background-color: rgba(0, 123, 255,0.7);
}

.buttons-container .close-button {
  background-color: rgba(200, 35, 51, 0.5);
}

.buttons-container .close-button:hover {
  background-color: rgba(200, 35, 51, 0.7);
}
</style>